/**
 * RunDetailHeading — heading line for the currently-selected run on the
 * Submission Detail page. Composes the prompt name, the provider tag,
 * a Primary badge if the run is the chosen primary, and a small
 * prompt-type badge so the reader sees which kind of run they're
 * looking at without scanning the metadata card.
 *
 * The prompt revision sits here too. The version number alone cannot answer
 * "did this run use the prompt I edited?" across environments, because each
 * environment numbers prompts with its own counter; the revision is the
 * commit date of the prompt file and reads the same everywhere.
 */
import type { ModelOutput } from '../../types';

interface Props {
    run: ModelOutput;
    promptName: string;
    promptType?: string;
}

export function RunDetailHeading({ run, promptName, promptType }: Props) {
    return (
        <>
            {promptName}
            <span className="provider-tag">{run.parameters.model || run.parameters.provider}</span>
            {run.parameters.promptRev && (
                <span
                    className="provider-tag"
                    style={{ marginLeft: 6 }}
                    title={`Prompt revision — the prompt file's last change date. Environment-independent, unlike v${run.parameters.promptVersion}.`}
                >
                    rev {run.parameters.promptRev}
                </span>
            )}
            {run.isPrimary && <span className="primary-badge">Primary</span>}
            {promptType && (
                <span className="prompt-type-badge" style={{ marginLeft: 8 }}>
                    {promptType}
                </span>
            )}
        </>
    );
}
